<template>
  <base-dropdown
    menu-on-right
    class="nav-item"
    tag="li"
    title-tag="a"
    title-classes="nav-link pr-0"
  >
    <a
      class="nav-link pr-0 pointer"
      @click.prevent="getNotifications"
      slot="title-container"
    >
      <div class="media align-items-center">
        <span
          class="avatar avatar-sm rounded-circle"
          style="background: #ffffff;"
        >
          <notification-bell
            iconColor="#000000"
            :count="notificationCounter"
            :upperLimit="1"
            counterLocation="upperRight"
            counterStyle="roundRectangle"
            counterBackgroundColor="#FF0000"
            counterTextColor="#FFFFFF"
            ding
            :size="20"
          />
        </span>
      </div>
    </a>

    <template>
      <div style="width: 450px;">
        <div class="dropdown-header noti-title">
          <h6 class="text-overflow m-0">Notificações</h6>
        </div>
  
        <div class="dropdown-divider mb-0"></div>

        <div id="notifications">
          <div
            v-for="notification in notifications"
            :key="notification.id"
            class="notification dropdown-item"
            @click="triggerNotification(notification)"
          >
            <div class="notification-content">
              <div class="notification-body">
                <span>{{ notification.content }}</span>
              </div>
            </div>
            <div class="notification-time text-muted text-uppercase">
              <span>{{ notification.created_at | formatDate('datetime') }}</span>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mt-2" v-if="notificationCounter">
          <button @click="readAllNotifications()" class="btn btn-sm btn-primary">
            MARCAR NOTIFICAÇÕES COMO LIDAS
          </button>
        </div>

        <div v-else>
          <div class="dropdown-item text-center text-muted">
            <span>Nenhuma notificação</span>
          </div>
        </div>
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import NotificationBell from "vue-notification-bell";
import { mapActions } from 'vuex';

export default {
  name: 'Notifications',
  components: {
    NotificationBell,
  },
  data: () => ({
    notificationPuller: null,
    openSupportModal: false,
    support: null,
    notificationRouteMapping: {
      'Preferredproduct': 'Produto Preferencial',
      'Product': 'Pesquisar Produtos',
      'User': 'Carteira de Clientes',
      'CommercialRelease': 'Liberações comerciais Pendentes',
      'Api::V1::SupportBridgeController': (notification) => {
        return {
          openSupportModal: true,
          support: {
            id: notification.notifiable_id,
            ...notification.data 
          }
        };
      }
    },
  }),
  methods: {
    ...mapActions(['triggerNotificationAction', 'triggerNotificationClassAction']),
    async readAllNotifications() {
      await this.$http.secured.get(`/api/v1/read_all_notifications`)
      this.getNotifications()
    },
    getNotificationsCounter() {
      this.$store.dispatch('getNotificationsCounter')
    },
    getNotifications() {
      this.$store.dispatch('getNotifications')
    },
    notificationParams(notification) {
      if (!notification.associable_type) return null;
      
      if (notification.associable_type == 'User') {
        if (!notification.associable_id) return { empty_user: true };

        return { user_id: notification.associable_id };
      }
      
      return { id: notification.associable_id }
    },
    triggerNotification(notification) {
      if (notification.associable_type == 'Api::V1::SupportBridgeController') {
        this.triggerNotificationAction(notification.associable_id)
        this.triggerNotificationClassAction(notification.associable_type)

        const action = this.notificationRouteMapping[notification.associable_type]
        if (typeof action === 'function') {
          const payload = action(notification)
          Object.assign(this.$data, payload)
        }

        return 
      }

      if (this.notificationRouteMapping[notification.associable_type] == this.$route.name ) {
        this.triggerNotificationAction(notification.associable_id)
        return
      }

      this.$router.push({ name: this.notificationRouteMapping[notification.associable_type], params: this.notificationParams(notification) })
    },
  },
  computed: {
    notifications() {
      return this.$store.state.notifications || []
    },
    notificationCounter() {
      return this.$store.state.notificationCounter || 0
    },
  },
  mounted() {
    this.notificationPuller = setInterval(this.getNotificationsCounter, 60000)
  },
  beforeUnmount() {
    clearInterval(this.notificationPuller)
  }
}
</script>

<style>
#notifications {
  max-height: 300px;
  overflow-y: auto;
}

#notifications .notification.dropdown-item {
  padding: 0.5rem 1rem;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#notifications .notification-body {
  white-space: pre-line;
}
</style>
